import { cloneDeep } from 'lodash';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ClientInterface } from '../data';
import { ContractService } from '../services/contract.service';
import { Transaction } from '../transaction/transaction';
import { UseCaseWithParam } from './common/use.case.with.params';

export interface GetParticipantsUseCaseParams {
    isFull?: boolean;
}

@Injectable()
export class GetParticipantsUseCase implements UseCaseWithParam<GetParticipantsUseCaseParams, Observable<Transaction<ClientInterface[]>>> {
    constructor(private contractService: ContractService) {}

    bind(params: GetParticipantsUseCaseParams): Observable<Transaction<ClientInterface[]>> {
        return this.contractService.getParticipants(params.isFull).pipe(
            map((transaction) =>
                transaction.map(
                    (participants) => Transaction.success(cloneDeep(participants)),
                    (throwable) => Transaction.error(throwable.message)
                )
            )
        );
    }
}
